export default __webpack_public_path__ + "static/media/alexandru-tudorache.db87dc0a.png";